import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import { useUserDetailsContext } from 'context/userDetailsContext';

const FilterContext = createContext();

export const FilterProvider = ({ children }) => {
  const { userDetails } = useUserDetailsContext();
  const [searchKeyword, setSearchKeyword] = useState('');
  const [practiceArea, setPracticeArea] = useState(userDetails?.user_preferences?.filters?.leads?.filter_practice_area || '');
  const [assignedTo, setAssignedTo] = useState(userDetails?.user_preferences?.filters?.leads?.assigned_to || []);
  const [sortType, setSortType] = useState(userDetails?.user_preferences?.filters?.leads?.sort_by_priority || null);

  // Clear all filters
  const clearFilters = useCallback(() => {
    setSearchKeyword('');
    setPracticeArea('');
    setAssignedTo([]);
    setSortType(null);
  }, []);

  // Check if any filters are active
  const hasActiveFilters = useMemo(() => {
    return !!(searchKeyword || practiceArea || assignedTo.length > 0 || sortType);
  }, [searchKeyword, practiceArea, assignedTo, sortType]);

  const value = useMemo(
    () => ({
      // State
      searchKeyword,
      practiceArea,
      assignedTo,
      sortType,
      hasActiveFilters,

      // Setters
      setSearchKeyword,
      setPracticeArea,
      setAssignedTo,
      setSortType,
      clearFilters,
    }),
    [searchKeyword, practiceArea, assignedTo, sortType, hasActiveFilters, clearFilters]
  );

  return <FilterContext.Provider value={value}>{children}</FilterContext.Provider>;
};

// Custom hook to use filter context
export const useFilters = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilters must be used within FilterProvider');
  }
  return context;
};
